import type { BAPProfile } from "@/types/bap";

export interface LocalWalletIdentity {
	bapId: string;
	/** Display name when the profile is known; otherwise a shortened BAP id. */
	label: string;
	/** True when the label is the shortened id, not a real name. */
	isFallbackLabel: boolean;
	image: string | null;
}

export function shortenBapId(bapId: string): string {
	if (bapId.length <= 12) {
		return bapId;
	}
	return `${bapId.slice(0, 6)}…${bapId.slice(-4)}`;
}

/**
 * Describe the wallet held on this device for the unlock screen (OPL-4241,
 * OPL-2541). The encrypted backup is opaque, so identity comes from the
 * cached current BAP id plus whatever the public profile lookup returns.
 */
export function describeLocalWallet(
	bapId: string | null,
	profile: BAPProfile | null | undefined
): LocalWalletIdentity | null {
	if (!bapId) {
		return null;
	}
	const name = profile?.identity?.alternateName?.trim();
	const image = profile?.identity?.image?.trim() || null;
	if (name) {
		return { bapId, label: name, isFallbackLabel: false, image };
	}
	return { bapId, label: shortenBapId(bapId), isFallbackLabel: true, image };
}
